module.exports = __webpack_public_path__ + "static/media/AddFileIcon.0026d8ab.svg";